import { DefaultPageSkeleton } from '@/components/ui/default-page-skeleton'

export const TeamPageSkeleton = () => {
  return <DefaultPageSkeleton />
}
